import { useMutation } from 'react-query';

import { updatePoapView as mutationFn } from 'api/endPoints/updatePoapView';
import { FilterReferenceKey } from 'api/queries/getFilterItemOptionsByRowType.query';
import { RowTypeKey } from 'api/queries/getRowTypeOptions.query';

export const useMutationUpdatePoapView = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    viewId: number;
    viewRows: {
        rowName: string;
        projectId: number;
        contractId: number;
        latestVersionId: number;
        compareVersionId: number;
        rowType: RowTypeKey;
        filterItem: FilterReferenceKey | undefined;
        filterItemReferences: string[];
        rowOrder: number;
        progressMeasurement: { code: string; partial: boolean };
        rowId?: number | undefined;
    }[];
}
